(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }


  customElements.define('sticky-header', StickyHeader);

  // BomBom — header scroll-driven : fond, couleurs, taille, 3 logos
  (function () {
    var wrapper  = document.querySelector('.header-wrapper');
    if (!wrapper) return;

    var header   = wrapper.querySelector('.header');
    var logoWrap = wrapper.querySelector('.header__heading-logo-wrapper');
    var logoW    = wrapper.querySelector('.logo--white');
    var logoB    = wrapper.querySelector('.logo--black');
    var logoMini = wrapper.querySelector('.logo--mini');

    var IS_HOMEPAGE = document.body.classList.contains('template-index');

    var SCROLL_END     = 220;
    var TARGET_PADDING = 10;
    var TARGET_LOGO_W  = 38;

    var MOBILE_LOGO_START = 160;
    var MOBILE_LOGO_END   = 38;
    var MOBILE_SCROLL_END = 180;

    var origPT, origPB, origLogoW;
    var isMobile = window.innerWidth < 990;

    function lerp(a, b, t) { return a + (b - a) * t; }

    function init() {
      isMobile = window.innerWidth < 990;
      var cs = window.getComputedStyle(header);
      origPT    = parseFloat(cs.paddingTop);
      origPB    = parseFloat(cs.paddingBottom);
      origLogoW = logoWrap ? logoWrap.offsetWidth : 120;

      if (IS_HOMEPAGE && isMobile) {
        if (logoWrap) logoWrap.style.width = MOBILE_LOGO_START + 'px';
        if (logoW)    logoW.style.opacity  = '1';
        if (logoB)    logoB.style.opacity  = '0';
        if (logoMini) logoMini.style.opacity = '0';
        wrapper.style.background   = 'transparent';
        wrapper.style.borderBottom = 'none';
        wrapper.classList.add('header-mobile-hero');
      }
    }

    function applyState(p) {
      var inv = 1 - p;

      wrapper.style.background   = 'rgba(255,255,255,' + p + ')';
      wrapper.style.borderBottom = p > 0
        ? '1px solid rgba(0,0,0,' + (p * 0.08) + ')'
        : 'none';

      var c = Math.round(255 * inv);
      wrapper.style.setProperty('--bombom-fg', 'rgb(' + c + ',' + c + ',' + c + ')');

      if (origPT !== undefined) {
        header.style.setProperty('padding-top',    lerp(origPT, TARGET_PADDING, p) + 'px', 'important');
        header.style.setProperty('padding-bottom', lerp(origPB, TARGET_PADDING, p) + 'px', 'important');
      }

      if (logoWrap && origLogoW) {
        logoWrap.style.width = lerp(origLogoW, TARGET_LOGO_W, p) + 'px';
      }

      var p1 = Math.min(p / 0.4, 1);
      var p2 = Math.max((p - 0.90) / 0.10, 0);
      if (logoW)    logoW.style.opacity    = 1 - p1;
      if (logoB)    logoB.style.opacity    = p1 * (1 - p2);
      if (logoMini) logoMini.style.opacity = p2;
    }

    function applyStateMobile(p) {
      var inv = 1 - p;

      wrapper.style.background   = 'rgba(255,255,255,' + p + ')';
      wrapper.style.borderBottom = p > 0
        ? '1px solid rgba(0,0,0,' + (p * 0.08) + ')'
        : 'none';

      var c = Math.round(255 * inv);
      wrapper.style.setProperty('--bombom-fg', 'rgb(' + c + ',' + c + ',' + c + ')');

      if (origPT !== undefined) {
        var mobilePTStart = 28;
        header.style.setProperty('padding-top',    lerp(mobilePTStart, TARGET_PADDING, p) + 'px', 'important');
        header.style.setProperty('padding-bottom', lerp(mobilePTStart, TARGET_PADDING, p) + 'px', 'important');
      }

      if (logoWrap) {
        logoWrap.style.width = lerp(MOBILE_LOGO_START, MOBILE_LOGO_END, p) + 'px';
      }

      var p1 = Math.min(p / 0.5, 1);
      var p2 = Math.max((p - 0.85) / 0.15, 0);
      if (logoW)    logoW.style.opacity    = 1 - p1;
      if (logoB)    logoB.style.opacity    = p1 * (1 - p2);
      if (logoMini) logoMini.style.opacity = p2;

      var isHero = p < 0.1;
      wrapper.classList.toggle('header-mobile-hero', isHero);

      var icons = wrapper.querySelectorAll('header-drawer, .header__icons');
      icons.forEach(function(el) {
        el.style.removeProperty('opacity');
        el.style.removeProperty('visibility');
      });
    }

    function update() {
      isMobile = window.innerWidth < 990;

      // Pages non-homepage : état final fixe, pas d'animation
      if (!IS_HOMEPAGE) {
        applyState(1);
        applyStateMobile(1);
        return;
      }

      if (isMobile) {
        var p = Math.min(window.scrollY / MOBILE_SCROLL_END, 1);
        applyStateMobile(p);
      } else {
        var p = Math.min(window.scrollY / SCROLL_END, 1);
        applyState(p);
      }
    }

    window.addEventListener('resize', function () {
      init();
      update();
    });

    requestAnimationFrame(function () {
      init();
      update();
    });

    window.addEventListener('scroll', update, { passive: true });
  })();


  } catch(e) { console.error(e); }
})();
})();
